module.exports = __webpack_public_path__ + "assets/img/box-2.d31f7ea7.png";